export const AEM_REDIRECT_VIEW_IDS = {
    SHOP: 'Shop',
    DEVICES: 'Devices',
    SELECT_YOUR_DEVICE: 'SelectYourDevice',
    QUICK_ORDER: 'QuickOrder',
    AUTO_DELIVERY_DETAILS: 'AutoDeliveryDetails',
} as const;

export type AemRedirectViewId = (typeof AEM_REDIRECT_VIEW_IDS)[keyof typeof AEM_REDIRECT_VIEW_IDS];
